module.exports = __webpack_public_path__ + "static/img/star-big.35b70d26.png";